
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { AlertTriangle, ArrowLeft, LogOut } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";

export default function ErrorPage() {
  const { user, signOut, tenantId } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await signOut();
    navigate("/login");
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 p-4">
      <div className="w-full max-w-md rounded-lg border bg-white p-8 shadow-sm">
        <div className="mb-6 flex flex-col items-center">
          <div className="flex h-12 w-12 items-center justify-center rounded-full bg-red-100">
            <AlertTriangle className="h-6 w-6 text-red-500" />
          </div>
          <h1 className="mt-4 text-2xl font-bold text-red-600">Access Denied</h1>
          <p className="text-center text-sm text-muted-foreground mt-2">
            {"An account for your organization already exists."}
          </p>
        </div>
        
        <div className="space-y-4">
          <div className="rounded-md bg-amber-50 p-4 border border-amber-200">
            <div className="flex items-start">
              <div className="ml-3 flex-1 text-sm text-amber-800">
                <p>
                    Currently only one master user can access AutoReply365 for an organization.
                    Please contact your organization administrator for access.                    
                </p>
                {user?.email && (
                  <p className="mt-2 font-medium">
                    Your email: {user.email}
                  </p>
                )}
                {tenantId && (
                  <p className="mt-1 text-xs">
                    Organization ID: {tenantId}
                  </p>
                )}
              </div>
            </div>
          </div>
          
          <div className="flex flex-col space-y-2">
            <Button variant="outline" asChild>
              <Link to="/login">
                <ArrowLeft className="mr-2 h-4 w-4" />
                Return to Login
              </Link>
            </Button>
            <Button variant="ghost" onClick={handleSignOut}>
              <LogOut className="mr-2 h-4 w-4" />
              Sign Out
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
